var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.registration
    ? _c(
        "div",
        [
          _c("h2", [_vm._v(_vm._s(_vm.$t("Registration.Confirmation.Title")))]),
          _vm._v(" "),
          _c("p", [
            _vm._v(
              _vm._s(
                _vm.$t("Registration.Confirmation.OrganisationDescription")
              )
            )
          ]),
          _vm._v(" "),
          _c("h2", [
            _vm._v(_vm._s(_vm.$t("Registration.Confirmation.UserInfoTitle")))
          ]),
          _vm._v(" "),
          _c("text-label-row", {
            attrs: {
              title: "Registration.FullName",
              id: "registrarName",
              labelClass: _vm.labelClass,
              valueClass: _vm.valueClass
            },
            model: {
              value: _vm.fullName,
              callback: function($$v) {
                _vm.fullName = $$v
              },
              expression: "fullName"
            }
          }),
          _vm._v(" "),
          _c("text-label-row", {
            attrs: {
              title: "Registration.Ssn",
              id: "registrarSsn",
              labelClass: _vm.labelClass,
              valueClass: _vm.valueClass
            },
            model: {
              value: _vm.registration.registrarSsn,
              callback: function($$v) {
                _vm.$set(_vm.registration, "registrarSsn", $$v)
              },
              expression: "registration.registrarSsn"
            }
          }),
          _vm._v(" "),
          _c("text-label-row", {
            attrs: {
              title: "Registration.Email",
              id: "email",
              labelClass: _vm.labelClass,
              valueClass: _vm.valueClass
            },
            model: {
              value: _vm.registration.registrarEmail,
              callback: function($$v) {
                _vm.$set(_vm.registration, "registrarEmail", $$v)
              },
              expression: "registration.registrarEmail"
            }
          }),
          _vm._v(" "),
          _c("text-label-row", {
            attrs: {
              title: "Registration.Procuration",
              value: _vm.registration.procuration
                ? _vm.$t("Registration.HasProcuration")
                : _vm.$t("Registration.NoProcuration"),
              id: "procuration",
              labelClass: _vm.labelClass,
              valueClass: _vm.valueClass
            }
          }),
          _vm._v(" "),
          _c("text-label-row", {
            attrs: {
              title: "Registration.ElectronicCommunication",
              value: _vm.$t("Registration.ElectronicCommunicationInfo"),
              id: "electronicCommunication",
              labelClass: _vm.labelClass,
              valueClass: _vm.valueClass
            }
          }),
          _vm._v(" "),
          _c("h2", [
            _vm._v(
              _vm._s(_vm.$t("Registration.Confirmation.OrganisationInfoTitle"))
            )
          ]),
          _vm._v(" "),
          _c("text-label-row", {
            attrs: {
              title: "Registration.OrganisationName",
              id: "organisationName",
              labelClass: _vm.labelClass,
              valueClass: _vm.valueClass
            },
            model: {
              value: _vm.registration.name,
              callback: function($$v) {
                _vm.$set(_vm.registration, "name", $$v)
              },
              expression: "registration.name"
            }
          }),
          _vm._v(" "),
          _c("text-label-row", {
            attrs: {
              title: "Registration.BusinessId",
              id: "businessId",
              labelClass: _vm.labelClass,
              valueClass: _vm.valueClass
            },
            model: {
              value: _vm.registration.businessId,
              callback: function($$v) {
                _vm.$set(_vm.registration, "businessId", $$v)
              },
              expression: "registration.businessId"
            }
          }),
          _vm._v(" "),
          _c("text-label-row", {
            attrs: {
              title: "Registration.FoundingYear",
              id: "foundingYear",
              labelClass: _vm.labelClass,
              valueClass: _vm.valueClass
            },
            model: {
              value: _vm.registration.foundingYear.toString(),
              callback: function($$v) {
                _vm.$set(_vm.registration.foundingYear, "toString()", $$v)
              },
              expression: "registration.foundingYear.toString()"
            }
          }),
          _vm._v(" "),
          _c("text-label-row", {
            attrs: {
              title: "Organisation.Language.Title",
              value: _vm.getLanguage(_vm.registration.language),
              id: "language",
              labelClass: _vm.labelClass,
              valueClass: _vm.valueClass
            }
          }),
          _vm._v(" "),
          _c(
            "button",
            {
              staticClass: "btn btn-secondary mb-5 login-page-button",
              attrs: { type: "button" },
              on: {
                click: function($event) {
                  return _vm.done()
                }
              }
            },
            [
              _vm._v(
                "\n    " +
                  _vm._s(_vm.$t("Registration.Btn_ToFrontPage")) +
                  "\n    "
              ),
              _c("i", { staticClass: "fas fa-chevron-right" })
            ]
          )
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }